import React, { Component } from 'react';
//import XMLData from './response.xml';
import { DropdownList } from 'react-widgets'
import "react-widgets/styles.css";
const axios = require('axios');
const { convertXML } = require("simple-xml-to-json");

export class Home extends Component {
    static displayName = Home.name;
    constructor(props) {
        super(props)
        this.state = {
            urls: undefined,
            filterUrls: [],
            selectedUrl: undefined
        }
    }
    componentDidMount() {
        axios.get("/sitemap.xml", {
            "Content-Type": "application/xml; charset=utf-8"
        })
            .then((response) => {
                const data = convertXML(response.data)
                const urls = []
                for (let d of data.urlset.children) {
                    urls.push(d.url.children[0].loc.content);
                }
                urls.sort();

                let filterUrls = [];
                for (let url of urls) {
                    let txt = url.replace("https://shop.zimcompass.com/", "")
                        .replace("https://localhost:44301", "")
                        .replaceAll("/", " ").replaceAll("-", " ")
                        .replace("classifieds", "").replace("used", "")
                        .replaceAll("=", " ").trim()
                        .replace(/(\w)(\w*)/g,
                            function (g0, g1, g2) { return g1.toUpperCase() + g2.toLowerCase(); });
                    if (txt === "") {
                        txt = "Home Page"
                    }
                    filterUrls.push({ url, txt });
                }

                this.setState({ filterUrls, urls });
            });
    }
    urlTxt = (url) => {
        if (url === undefined) {
            return;
        }
        let txt = url.replace("https://shop.zimcompass.com/", "")
            .replace("https://localhost:44301", "")
            .replaceAll("/", " ").replaceAll("-", " ")
            .replace("classifieds", "").replace("used", "")
            .replaceAll("=", " ").trim()
            .replace(/(\w)(\w*)/g,
                function (g0, g1, g2) { return g1.toUpperCase() + g2.toLowerCase(); });
        if (txt === "") {
            txt = "Home Page"
        }
        return txt
    }
    onSearchChange = (value) => {
        this.setState({ selectedUrl: value },
            () => {
                const win = window.open(value.url);
                if (win != null) {
                    win.focus();
                }});
    }
    render() {
        return (
            <section>
                <header>
                    <h1 className="text-center">All Product Pages</h1>
                    {this.state.urls &&
                        <div className="all-pages">
                            <div>
                                <DropdownList
                                    filter='contains'
                                    data={this.state.filterUrls}
                                    dataKey='url'
                                    textField='txt'
                                    value={this.state.selectedUrl}
                                    onChange={value => this.onSearchChange(value)}
                                    placeholder="Search Page"
                                />
                            <ul className="all-pages-list">
                                    {this.state.urls.map((url, index) =>
                                        <li key={index}>
                                            <a href={url}>{this.urlTxt(url)}</a>
                                        </li>
                                    )}
                                </ul>
                            </div>
                        </div>
                    }
                </header>
            </section>
        );
    }
}
